module.exports = __webpack_public_path__ + "static/testing-mastery-f4a651b0aad6633d9e7491169a94b2ba.png";